import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { toast } from "react-toastify";
import OrderTable from '../components/OrderTable';
import { SocketRPC, socketEmit } from '../lib/socket';
import { useOrderHistory, useOrderSearchParams } from '../store/orders';
import useUser from '../store/user';

const OrdersHistoryPage = () => {
	const {orders, setOrders, ordersLoaded, setOrdersLoaded } = useOrderHistory();
	const { user } = useUser();
	const { producerKey, orderSourceKey, partnerKey } = user || {};
	const { orderSearchParams, setOrderSearchParams, activePage, setActivePage, pageSize, setPageSize, noHistorySearchCriteria, setNoHistorySearchCriteria } = useOrderSearchParams();
	const [searchButtonDisabled, setSearchButtonDisabled] = useState(false);

	const isFirstRender = useRef(true);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
		} else {
			const {generalSearchQuery, dateRange, orderStatus, sortField, sortDirection} = orderSearchParams || {};

			Promise.resolve()
				.then(() => {
					setOrdersLoaded(false);
					if ((generalSearchQuery && generalSearchQuery !== '')) {
						const openSearchReq: any = {
							searchText: generalSearchQuery,
							producerKey,
							orderSourceKey,
							partnerKey,
							pageIndex: activePage - 1,
							// sortField: 'time.lateDelivery', // TEMP: hardcorded while opensearch reindexes with keywords
							sortDirection: sortDirection === 1 ? 'desc' : 'asc',
						};

						if (dateRange) {
							openSearchReq.startDate = dateRange.startDate;
							openSearchReq.endDate = dateRange.endDate;
						}

						setNoHistorySearchCriteria(false);
						return socketEmit(
							SocketRPC.SearchOrderHistory, {
								user,
								...openSearchReq,
							}
						);
					}

					if (dateRange && dateRange.startDate && dateRange.endDate) {
						setNoHistorySearchCriteria(false);
						return socketEmit(SocketRPC.GetOrderHistory, {
							user,
							startDate: dateRange.startDate,
							endDate: dateRange.endDate,
							partnerKey,
							orderSourceKey,
							producerKey,
							orderStatus,
							sortField,
							sortDirection: sortDirection === 1 ? 'desc' : 'asc',
							pageIndex: activePage - 1,
							pageSize,
						});
					}

					setActivePage(1);
					setNoHistorySearchCriteria(true);
					return Promise.resolve({ success: true, orders: [] });

				})
				.then((res) => {
					if (!res.success) {
						setOrders({});
						throw new Error(res.error);
					}
					setOrders(_.keyBy(res.orders, 'orderKey'));
				})
				.catch((err) =>
					{
						toast.error(
							`Error searching archived orders. Please try again`
						);
						setSearchButtonDisabled(false);
						console.log(`Could not search archived orders`, err);
					}
				)
				.finally(() => setOrdersLoaded(true));
		}
	}, [JSON.stringify(orderSearchParams), activePage, pageSize]);

	const paginationProps = {
		activePage,
		setActivePage,
		pageSize,
		setPageSize,
	};

	const OrderTableProps = {
		type: 'history',
		orders,
		ordersLoaded,
		setOrderSearchParams,
		noHistorySearchCriteria,
		searchButtonDisabled,
		setSearchButtonDisabled,
		paginationProps: noHistorySearchCriteria ? null : paginationProps,
	};

	return OrderTable(OrderTableProps);
};

export default OrdersHistoryPage;
